import React, {useState} from 'react'
import { Flores } from '../assets';
import { GiHummingbird } from 'react-icons/gi';
// Modal Sheet
import Sheet from 'react-modal-sheet';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
// React player
// Paquete para traduccion i18n
import { useTranslation } from 'react-i18next';

const Experiencia = () => {

    // Hook importado de 'react-i18next'
    const { t } = useTranslation(); 

    // Set State del modal Sheeet for each modal
    const [isOpen, setOpen] = useState(false);

  return (
    <div>
        <button onClick={() => setOpen(true)} className='text-white flex items-center bg-black rounded-3xl bg-opacity-60 py-4 w-[19rem] justify-center font-bold text-sm gap-2 -mt-16 lg:w-96 hover:duration-150 hover:bg-secondary border-2 border-secondary'>
                <GiHummingbird className='text-2xl'/> 
                <img src={Flores} alt="flores" className='w-16'/> 
                {t('home_modal1')}
        </button>
        <Sheet isOpen={isOpen} onClose={() => setOpen(false)}>
            <Sheet.Container>
                <Sheet.Header />
                    <Sheet.Content className='mx-12 my-3'>
                        <div className='flex items-center justify-center gap-3 mb-2'><img src={Flores} alt="flores" className='w-16'/> <h1 className='font-bold text-2xl'>Tzintzún</h1><img src={Flores} alt="flores" className='w-16 rotate-180'/> </div>
                        <p className='text-justify leading-6'>{t('home_modal2')}</p>
                        <div className='flex justify-center gap-6 py-5 items-center'>
                            <a href="https://www.instagram.com/ar/1057928941556470/" className='bg-secondary p-4 rounded-2xl text-2xl text-third hover:duration-150 hover:bg-primary'><FaInstagram/> </a>
                            <GiHummingbird className='text-5xl'/>
                            <a href="https://www.facebook.com/fbcameraeffects/tryit/1057928941556470/" className='bg-secondary p-4 rounded-2xl text-2xl text-third hover:duration-150 hover:bg-primary'><FaFacebook /></a>
                        </div>
                        <p className='text-justify'>{t('home_modal3')}</p>
                    </Sheet.Content>
                </Sheet.Container>
            <Sheet.Backdrop />
        </Sheet>
    </div>
  )
}

export default Experiencia